import React, { useEffect } from 'react';
import Navbar from './components/navbar';
import Hero from './components/hero';
import About from './components/about';
import Services from './components/services';
import Footer from './components/footer';
import './App.css';

function App() {

  useEffect(() => { 
    const handleRightClick = (e) => { 
      e.preventDefault(); 
    };
  window.addEventListener('contextmenu', handleRightClick);
  return () => { 
    window.removeEventListener('contextmenu', handleRightClick); 
    };
  }, []);

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Footer />
    </div>
  );
}

export default App;